import { memo } from "react";
import type { NavigationMenuLinkProps as RadixNavigationMenuLinkProps } from "@radix-ui/react-navigation-menu";
import { NavigationMenuLink, navigationMenuTriggerStyle } from "@/components/ui/navigation-menu";
import { cn } from "@/lib/utils";
import { normalizePath } from "@/utils";

export type NavigationMenuLinkProps = {} & RadixNavigationMenuLinkProps;

const NavigationLink = ({ className, href = "#", children, ...rest }: NavigationMenuLinkProps) => {
  return (
    <NavigationMenuLink
      className={cn(
        navigationMenuTriggerStyle(),
        "text-md [&>svg]:w-5 [&>svg]:h-5 !bg-transparent hover:!bg-transparent focus:!bg-transparent data-[state=open]:!bg-transparent data-[state=open]:!underline underline-offset-4 hover:!text-[#4381E5] data-[state=open]:!text-[#4381E5]",
        className
      )}
      href={normalizePath(href)}
    >
      {children}
      <div
        className="absolute bottom-[-10px] left-4 right-4 h-[2px] bg-[#4381E5] transition-opacity duration-300 
    group-data-[state=open]:opacity-100 opacity-0"
      />
    </NavigationMenuLink>
  );
};

export default memo(NavigationLink);
